module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("559Be"))).then(() => parcelRequire('fThBo'));